import List from "@/components/list";
import Bus from "./bus";
import router from "@/router";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};

  // 修改微视频
  function handleUpdate({ row }) {
    Bus.$emit("ReceiveMessage", Object.assign({}, row));
  }

  // 删除微视频
  async function deleteShortVideo(uuid) {
    Bus.$emit("deleteShortVideo", uuid);
  }

  // 上下线微视频
  function shortVideoOnline(uuid, onlineStatus) {
    Bus.$emit("shortVideoOnline", {
      id: [uuid],
      status: onlineStatus
    });
  }

  // 微视频置顶
  function shortVideoTop(uuid, topStatus) {
    Bus.$emit("shortVideoTop", {
      id: [uuid],
      status: topStatus
    });
  }
  //预览首页
  function showImg(vo) {
    Bus.$emit("showImg", vo.row);
  }
  function showVideo(vo) {
    router.push({ path: "/shortVideo/play", query: { id: vo.row.uuid } });
  }

  const Deal = ({ props: { vo } }) => {
    const video = vo.row;
    const canNotEdit = video.onlineStatus == 1;
    const canNotDelete = video.onlineStatus == 1;
    const dealConf = [["icon-start", "预览", () => showVideo(vo), ""]];
    if (canNotEdit) {
      dealConf.push([
        "icon-edit-disable",
        "编辑",
        () => {},
        "shortVideo:update"
      ]);
    } else {
      dealConf.push([
        "icon-edit",
        "编辑",
        () => handleUpdate(vo),
        "shortVideo:update"
      ]);
    }
    if (video.setTop == 1) {
      dealConf.push([
        "icon-cancel",
        "取消置顶",
        () => shortVideoTop(video.uuid, 0),
        "shortVideo:top"
      ]);
    } else {
      dealConf.push([
        "icon-top",
        "置顶",
        () => shortVideoTop(video.uuid, 1),
        "shortVideo:top"
      ]);
    }

    if (video.onlineStatus == 1) {
      dealConf.push([
        "icon-down",
        "下线",
        () => shortVideoOnline(video.uuid, 0),
        "shortVideo:online"
      ]);
    } else {
      dealConf.push([
        "icon-up",
        "上线",
        () => shortVideoOnline(video.uuid, 1),
        "shortVideo:online"
      ]);
    }

    if (canNotDelete) {
      dealConf.push([
        "icon-delete-disable",
        "删除",
        () => {},
        "shortVideo:delete"
      ]);
    } else {
      dealConf.push([
        "icon-delete",
        "删除",
        () => deleteShortVideo(video.uuid),
        "shortVideo:delete"
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };
  const Img = ({ props: { vo } }) => {
    return (
      <div onClick={() => showImg(vo)}>
        <img src={vo.row.coverUrl} style="width:100%" />
      </div>
    );
  };

  const AccountTableConfig = [
    /*{
      type: "selection",
      label: "main"
    },*/
    {
      label: "视频名称",
      minWidth: "150",
      prop: "videoName",
      showOverflowTooltip: true
    },
    {
      label: "封面",
      minWidth: "150",
      prop: "coverUrl",
      render: vo => <Img vo={vo} />
    },
    {
      label: "是否置顶",
      prop: "setTopName",
      minWidth: "130"
    },
    {
      label: "视频分类",
      prop: "categoryName",
      minWidth: "130",
      showOverflowTooltip: true
    },
    {
      label: "发布主体",
      prop: "publisherName",
      minWidth: "130",
      showOverflowTooltip: true
    },
    {
      label: "视频状态",
      prop: "onlineStatusName",
      minWidth: "130"
    },
    {
      label: "视频数据",
      prop: "videoData",
      minWidth: "150",
      render: vo => (
        <div>
          <div class="play">
            <span class="icon_see"></span>
            <span>{vo.row.playNum}</span>
          </div>
          <div class="play">
            <span class="icon_collection"></span>
            <span>{vo.row.collectionNum}</span>
          </div>
          <div class="play">
            <span class="icon_comment"></span>
            <span>{vo.row.commentNum}</span>
          </div>
        </div>
      )
    },
    {
      label: "发布时间",
      prop: "onlineDate",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      fixed: "right",
      minWidth: "200",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
